"use client";

import { useQuery } from "@tanstack/react-query";
import React from "react";

import FetchError from "./fetch-error";
import Loading from "./loading";

import api from "@/lib/api";

type MetricSectionProps = {
  metricKey: string;
  title: string;
  url: string;
  subtitle: string;
  actionText: string;
};

type StatisticsDataProps = {
  [key: string]: string | { [key: string]: string };
};

export default function MetricSection({ metricKey, title, url, subtitle, actionText }: MetricSectionProps) {
  const { data, error, isPending } = useQuery({
    queryKey: ["statistics", "index"],
    queryFn: () => api.get<StatisticsDataProps>("/cms/statistics/index/?site_name=hcap"),
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  const value = typeof data?.[metricKey] === "object" ? "-" : data?.[metricKey] || "-";

  return (
    <>
      <div className="d-flex justify-content-center align-items-center g2-gray-row py-5 my-5 position-relative">
        <p className="lh-1 fs-5 text-end text-uppercase m-0 px-2">
          {actionText.split(" ").map((word, index) => (
            <React.Fragment key={index}>
              {word}
              <br />
            </React.Fragment>
          ))}
        </p>

        <p className="display-3 g2-text-orange m-0 px-2">{value}</p>
        <p className="g2-text-gray text-uppercase lh-1 fs-5 m-0 px-2" style={{ maxWidth: "40%" }}>
          <a href={url} className="g2-text-burgundy fw-bold text-decoration-none stretched-link">
            {title}
          </a>{" "}
          {subtitle}
        </p>
      </div>
    </>
  );
}
